import { render, staticRenderFns } from "./ContactDetailBox.vue?vue&type=template&id=76b7e92e&scoped=true"
import script from "./ContactDetailBox.vue?vue&type=script&lang=js"
export * from "./ContactDetailBox.vue?vue&type=script&lang=js"
import style0 from "./ContactDetailBox.vue?vue&type=style&index=0&id=76b7e92e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b7e92e",
  null
  
)

export default component.exports